<!-- Start Footer -->
<footer class="glass py-8 border-t border-white/25">
   <div class="container">
      <div class="grid md:grid-cols-12 items-center">
         <div class="md:col-span-3">
         </div>

         <div class="md:col-span-6 md:mt-0 mt-8">
            <div class="text-center">
               <p class="flex flex-wrap justify-center gap-x-4 gap-y-1">
                  <a routerLink="/business" class="link">{{ 'components.navbar.myShops' | translate }}</a>
                  <a routerLink="/about" target="_blank" class="link">{{ 'components.footer.policy' | translate }}</a>
               </p>
               <p>oopsy&#64;oopsy.app<a href="mailto:oopsy@oopsy.app"
                     class="size-8 inline-flex items-center justify-center tracking-wide align-middle link">
                     <i data-feather="mail" class="align-middle" title="email"></i></a>
               </p>
            </div>
         </div>
      </div><!--end row-->
   </div><!--end container-->
</footer><!--end footer-->
<!-- End Footer -->